export const TKeyEmails = {
  EMAIL_HELLO: "EMAIL_HELLO",
  EMAIL_BEST_REGARDS: "EMAIL_BEST_REGARDS",
  EMAIL_IGNORE_REQUEST: "EMAIL_IGNORE_REQUEST",
  EMAIL_TEAM: "EMAIL_TEAM",
  EMAIL_RESET_PASSWORD_TITLE: "EMAIL_RESET_PASSWORD_TITLE",
  EMAIL_RESET_PASSWORD_TEXT: "EMAIL_RESET_PASSWORD_TEXT",
  EMAIL_CONFIRM_TITLE: "EMAIL_CONFIRM_TITLE",
  EMAIL_CONFIRM_TEXT: "EMAIL_CONFIRM_TEXT",
  EMAIL_CONFIRM_BUTTON: "EMAIL_CONFIRM_BUTTON",
  EMAIL_CHANGE_EMAIL_TITLE: "EMAIL_CHANGE_EMAIL_TITLE",
  EMAIL_CHANGE_EMAIL_TEXT: "EMAIL_CHANGE_EMAIL_TEXT",
  EMAIL_PROSPECTS_READY_TITLE: "EMAIL_PROSPECTS_READY_TITLE",
  EMAIL_PROSPECTS_READY_TEXT: "EMAIL_PROSPECTS_READY_TEXT",
  EMAIL_PROSPECTS_READY_BUTTON: "EMAIL_PROSPECTS_READY_BUTTON",
  EMAIL_PROSPECTS_ADVANCE_TITLE: "EMAIL_PROSPECTS_ADVANCE_TITLE",
  EMAIL_PROSPECTS_ADVANCE_TEXT: "EMAIL_PROSPECTS_ADVANCE_TEXT",
  EMAIL_PROSPECTS_ADVANCE_BUTTON: "EMAIL_PROSPECTS_ADVANCE_BUTTON",
  EMAIL_PROSPECTS_POTENTIAL_TITLE: "EMAIL_PROSPECTS_POTENTIAL_TITLE",
  EMAIL_PROSPECTS_POTENTIAL_TEXT: "EMAIL_PROSPECTS_POTENTIAL_TEXT",
  EMAIL_PROSPECTS_POTENTIAL_BUTTON: "EMAIL_PROSPECTS_POTENTIAL_BUTTON",
  EMAIL_IMPORTED_PROFILE_DETECTION_TITLE: "EMAIL_IMPORTED_PROFILE_DETECTION_TITLE",
  EMAIL_IMPORTED_PROFILE_DETECTION_TEXT: "EMAIL_IMPORTED_PROFILE_DETECTION_TEXT",
  EMAIL_IMPORTED_PROFILE_DETECTION_COUNT: "EMAIL_IMPORTED_PROFILE_DETECTION_COUNT",
  EMAIL_IMPORTED_PROFILE_DETECTION_BUTTON: "EMAIL_IMPORTED_PROFILE_DETECTION_BUTTON",
  EMAIL_INVITE_BUTTON: "EMAIL_INVITE_BUTTON",
  EMAIL_COMPANY_INVITE_TITLE: "EMAIL_COMPANY_INVITE_TITLE",
  EMAIL_COMPANY_INVITE_TEXT: "EMAIL_COMPANY_INVITE_TEXT",
  EMAIL_PROJECT_INVITE_TITLE: "EMAIL_PROJECT_INVITE_TITLE",
  EMAIL_PROJECT_INVITE_TEXT: "EMAIL_PROJECT_INVITE_TEXT",
  EMAIL_ADMIN_NEW_USER_TITLE: "EMAIL_ADMIN_NEW_USER_TITLE",
  EMAIL_ADMIN_NEW_USER_TEXT: "EMAIL_ADMIN_NEW_USER_TEXT",
  EMAIL_ADMIN_NEW_USER_REFERRED: "EMAIL_ADMIN_NEW_USER_REFERRED",
  EMAIL_ADMIN_NEW_USER_LINK: "EMAIL_ADMIN_NEW_USER_LINK",
  EMAIL_ADMIN_DELETE_ACCOUNT_TITLE: "EMAIL_ADMIN_DELETE_ACCOUNT_TITLE",
  EMAIL_ADMIN_DELETE_ACCOUNT_TEXT: "EMAIL_ADMIN_DELETE_ACCOUNT_TEXT",
  EMAIL_ADMIN_DELETE_ACCOUNT_DEADLINE: "EMAIL_ADMIN_DELETE_ACCOUNT_DEADLINE",
  EMAIL_ADMIN_EXPERT_AUDIT_TITLE: "EMAIL_ADMIN_EXPERT_AUDIT_TITLE",
  EMAIL_ADMIN_EXPERT_AUDIT_TEXT: "EMAIL_ADMIN_EXPERT_AUDIT_TEXT",
  EMAIL_ADMIN_LABEL_USER: "EMAIL_ADMIN_LABEL_USER",
  EMAIL_ADMIN_LABEL_PROJECT: "EMAIL_ADMIN_LABEL_PROJECT",
  EMAIL_ADMIN_LABEL_PROJECT_ID: "EMAIL_ADMIN_LABEL_PROJECT_ID",
  EMAIL_ADMIN_LABEL_AVATAR: "EMAIL_ADMIN_LABEL_AVATAR",
  EMAIL_ADMIN_LABEL_QUANTITY: "EMAIL_ADMIN_LABEL_QUANTITY",
  EMAIL_ADMIN_LABEL_SEARCH_ID: "EMAIL_ADMIN_LABEL_SEARCH_ID",
  EMAIL_ADMIN_LABEL_CLIENT: "EMAIL_ADMIN_LABEL_CLIENT",
  EMAIL_ADMIN_LABEL_REASON: "EMAIL_ADMIN_LABEL_REASON",
  EMAIL_ADMIN_LABEL_AMOUNT: "EMAIL_ADMIN_LABEL_AMOUNT",
  EMAIL_ADMIN_LABEL_UNKNOWN: "EMAIL_ADMIN_LABEL_UNKNOWN",
  EMAIL_ADMIN_PAYMENT_ISSUE_TITLE: "EMAIL_ADMIN_PAYMENT_ISSUE_TITLE",
  EMAIL_ADMIN_PAYMENT_NOT_GRANTED: "EMAIL_ADMIN_PAYMENT_NOT_GRANTED",
  EMAIL_ADMIN_PAYMENT_NOT_GRANTED_IMPACT: "EMAIL_ADMIN_PAYMENT_NOT_GRANTED_IMPACT",
} as const;
